// src/api/faceRecognition.js
import axios from 'axios'

// 创建专用 axios 实例（可选：未来加拦截器、baseURL 等）
const faceApi = axios.create({
    // 注意：这里用相对路径 /api，由 vue.config.js 代理到 http://localhost:8121
    baseURL: '/api'
})

/**
 * 上传视频（旧版本，保留兼容性）
 * @param {File} file - 视频文件对象
 * @returns {Promise}
 */
export function uploadVideo(file) {
    const formData = new FormData()
    formData.append('video', file)

    return faceApi.post('/faceRecognition/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

/**
 * 上传视频文件（新版本，包含手机号和文件名）
 * @param {string} phoneNumber - 手机号
 * @param {string} fileName - 文件名
 * @param {File} file - 视频文件对象
 * @returns {Promise}
 */
export function uploadVideoWithInfo(phoneNumber, fileName, file) {
    const formData = new FormData()
    formData.append('phoneNumber', phoneNumber)
    formData.append('fileName', fileName)
    formData.append('file', file)

    return faceApi.post('/faceRecognition/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

/**
 * 读取视频（获取处理结果等）
 * @param {number} page - 页码，默认 1
 * @param {number} pageSize - 每页大小，默认 10
 * @param {string} search - 搜索关键词，默认 ''
 * @returns {Promise}
 */
export function getFileData(page = 1, pageSize = 10, search = '') {
    return faceApi.post('/faceRecognition/folders', {
        page,
        pageSize,
        search
    })
}

/**
 * 添加手机号
 * @param {string} phoneNumber - 手机号
 * @returns {Promise}
 */
export function addPhoneNumber(phoneNumber) {
    return faceApi.post('/faceRecognition/addPhoneNumber', {
        phoneNumber
    })
}